import { useAtomValue } from "jotai";
import { shoppingCartAtom } from "@/store/shoppingCartAtoms";
import { cartUnitCount } from "@utils/cartUnitCount";
import { DesktopNav } from "./DesktopNav";
import { MobileNav } from "./MobileNav";
import { MobileDrawer } from "./MobileDrawer";

export const CustomerNavigation = () => {
    // CustomerContainer reads the cart for a shopper who can shop (B-15).
    const cartCount = cartUnitCount(useAtomValue(shoppingCartAtom));

    return (
        <header className="bg-secondary text-secondary-content shadow-sm">
            <div className="max-w-7xl mx-auto px-4 h-16 md:h-20 flex items-center">
                <DesktopNav cartCount={cartCount} />
                <MobileNav cartCount={cartCount} />
            </div>
            <MobileDrawer />
        </header>
    );
};
